<script>
/**
 * Utils to manage queyr params dates
 */

import { isEqual } from 'lodash';

export default {
  data() {
    return {
      dateUtilsDefaultFormat: 'YYYY-MM-DD',
    };
  },
  methods: {
    replaceDateInQuery(date, queryKey, format) {
      format = format || this.dateUtilsDefaultFormat;

      const query = Object.assign({}, this.$route.query);
      const mDate = this.$moment(date);
      if (mDate.isValid) {
        const qDate = mDate.format(format);
        query[queryKey] = qDate;
        if (!isEqual(query, this.$route.query)) {
          this.$router.replace({ query });
        }
        return true;
      }
      return false;
    },
  },
};
</script>
